import { render, staticRenderFns } from "./VerDetalleImagenes.vue?vue&type=template&id=4c9cac76"
import script from "./VerDetalleImagenes.vue?vue&type=script&lang=js"
export * from "./VerDetalleImagenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports